import moment from 'moment-timezone'

const minutesUntilNextStop = (timestamp: string): number => {
  const now = moment()
  const then = moment(timestamp)
  return Math.round(moment.duration(then.diff(now)).asMinutes())
}

export const lessThanHours = (startAtTime: string, hours: number): boolean => {
  const totalMinutes = hours * 60
  return Math.abs(minutesUntilNextStop(startAtTime)) <= totalMinutes
}
